import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    heading: `'Abel', sans-serif`,
    body: `'Abel', sans-serif`,
  },
})

export default theme
